export default {
  path: '/login',
  meta: {
    title: '登陆',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/login`),
}



// WEBPACK FOOTER //
// ./src/views/Login/router.js